import { EditEditorsComponent } from './edit-editors/edit-editors.component';
import { AddEditorsComponent } from './add-editors/add-editors.component';
import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { ListEditorsComponent } from './list-editors/list-editors.component';

export const routesEditors: Routes = [
    { path: 'editors', component: ListEditorsComponent},
    { path: 'editors/add', component: AddEditorsComponent},
    { path: 'editors/:id/edit', component: EditEditorsComponent}
];

export const EditorsRoutes: ModuleWithProviders = RouterModule.forChild(routesEditors);
